<div class="col-6">
  <h5 class="inner-heading">About</h5>
</div>
<div *ngIf="!editDetails" class="viewMode-sec">
  <div class="col-6 text-right viewMode-inner">
    <ng-container *ngIf="!viewMode && showEditButton">
      <button class="back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit()">
        <i class="fa fa-pencil"></i>
        Edit
      </button>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">First Name</p>
      <label class="label-dark">{{
        beneficiaryData?.fName
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Middle Name</p>
      <label class="label-dark">
        {{
          beneficiaryData?.mName ? beneficiaryData?.mName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Last Name</p>
      <label class="label-dark">{{
        beneficiaryData?.lName
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Gender</p>
      <label class="label-dark">{{
        beneficiaryData?.gender?.name
        ? beneficiaryData?.gender?.name
        : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Date Of Birth</p>
      <label class="label-dark">{{
        beneficiaryData?.dob ? (beneficiaryData?.dob | ImgDateFormat) : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Social Security Number</p>
      <label class="label-dark">
        {{
          beneficiaryData?.ssn ? beneficiaryData?.ssn : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Alias Name</p>
      <label class="label-dark">{{
        beneficiaryData?.aliasName[0]?.fName ? beneficiaryData?.aliasName[0]?.fName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Email Id</p>
      <label class="label-dark">{{
        primaryEmail?.email
        }}</label>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Place of Birth</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">Country</p>
      <label class="label-dark">{{
        beneficiaryData?.countryCode?.countryName ? beneficiaryData?.countryCode?.countryName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">State</p>
      <label class="label-dark">{{
        beneficiaryData?.birthStateProvinceName ? beneficiaryData?.birthStateProvinceName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Citizenship</p>
      <label class="label-dark">{{
        beneficiaryData?.ctznshipCountryCode?.countryName ? beneficiaryData?.ctznshipCountryCode?.countryName : "--"
        }}</label>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Physical Address Details</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">Address 1</p>
      <label class="label-dark">{{
        beneAddress[0]?.addressLine1 ? beneAddress[0]?.addressLine1 : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Address 2</p>
      <label class="label-dark">{{
        beneAddress[0]?.addressLine2 ? beneAddress[0]?.addressLine2 : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Country</p>
      <label class="label-dark">{{
        beneAddress[0]?.countryCode?.countryName ? beneAddress[0]?.countryCode?.countryName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">State</p>
      <label class="label-dark">{{
        beneAddress[0]?.stateProvinceName ? beneAddress[0]?.stateProvinceName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">City</p>
      <label class="label-dark">{{
        beneAddress[0]?.city ? beneAddress[0]?.city : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Area</p>
      <label class="label-dark">{{
        beneAddress[0]?.locality ? beneAddress[0]?.locality : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Zip / Postal Code</p>
      <label class="label-dark">{{
        beneAddress[0]?.postCode ? beneAddress[0]?.postCode : "--"
        }}</label>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Foreign Address Details</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">Address 1</p>
      <label class="label-dark">{{
        beneAddress[1]?.addressLine1 ? beneAddress[1]?.addressLine1 : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Address 2</p>
      <label class="label-dark">{{
        beneAddress[1]?.addressLine2 ? beneAddress[1]?.addressLine2 : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Country</p>
      <label class="label-dark">{{
        beneAddress[1]?.countryCode?.countryName ? beneAddress[1]?.countryCode?.countryName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">State</p>
      <label class="label-dark">{{
        beneAddress[1]?.stateProvinceName ? beneAddress[1]?.stateProvinceName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">City</p>
      <label class="label-dark">{{
        beneAddress[1]?.city ? beneAddress[1]?.city : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Area</p>
      <label class="label-dark">{{
        beneAddress[1]?.locality ? beneAddress[1]?.locality : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Zip / Postal Code</p>
      <label class="label-dark">{{
        beneAddress[1]?.postCode ? beneAddress[1]?.postCode : "--"
        }}</label>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Passport Details</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">Passport No.</p>
      <label class="label-dark">{{
        beneficiaryData?.passport[0]?.passportNo ? beneficiaryData?.passport[0]?.passportNo : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Issuing Authority</p>
      <label class="label-dark">{{
        beneficiaryData?.passport[0]?.issueCountryCode?.countryName ? beneficiaryData?.passport[0]?.issueCountryCode?.countryName : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Date of Issue</p>
      <label class="label-dark">{{
        beneficiaryData?.passport[0]?.issueDate ? (beneficiaryData?.passport[0]?.issueDate | ImgDateFormat) : "--"
        }}</label>
    </div>
    <div class="col-4 mb-2">
      <p class="label-light m-0">Date of Expiry</p>
      <label class="label-dark">{{
        beneficiaryData?.passport[0]?.expiryDate ? (beneficiaryData?.passport[0]?.expiryDate | ImgDateFormat): "--"
        }}</label>
    </div>
  </div>

  <div class="clearfix"></div>

  <div class="row mt-4">
    <div class="col-12">
      <h5 class="labelText">Additional Info</h5>
    </div>
  </div>

  <div class="row">
    <div class="col-4 mb-2">
      <p class="label-light m-0">Visa Sponsor</p>
      <label class="label-dark">{{beneficiaryData?.visaSponsor ? beneficiaryData?.visaSponsor : '--'}}</label>
    </div>
  </div>

</div>




<mat-card>
  <div *ngIf="editDetails">
    <form class="ben-form" [formGroup]="beneSelfDetailsForm">

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">First Name</label>
            <input class="m-0" type="text" id="firstName" [ngClass]="{
              'im-input-error':
                (beneSelfDetailsForm.get('fName').touched || submitted) &&
                beneSelfDetailsForm.get('fName').errors?.required 
            }" pattern="^[\D]*$" formControlName="fName" required>
            <span class="invalid-message" *ngIf="
            (beneSelfDetailsForm.get('fName').touched || submitted) &&
            beneSelfDetailsForm.get('fName').errors?.required 
          ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="
            (beneSelfDetailsForm.get('fName').touched || submitted) &&
            beneSelfDetailsForm.get('fName').errors?.pattern
          ">
          {{ getGlobalErrorMessages("ALPHABETS_SPLCHARS") }}
        </span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">Middle Name</label>
            <input class="m-0" type="text" id="middleName" formControlName="mName">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">Last Name</label>
            <input class="m-0" type="text" id="lastName" [ngClass]="{
              'im-input-error':
                (beneSelfDetailsForm.get('lName').touched || submitted) &&
                beneSelfDetailsForm.get('lName').errors?.required 
            }" pattern="^[\D]*$" formControlName="lName" required>
            <span class="invalid-message" *ngIf="
            (beneSelfDetailsForm.get('lName').touched || submitted) &&
            beneSelfDetailsForm.get('lName').errors?.required 
          ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="
            (beneSelfDetailsForm.get('lName').touched || submitted) &&
            beneSelfDetailsForm.get('lName').errors?.pattern
          ">
          {{ getGlobalErrorMessages("ALPHABETS_SPLCHARS") }}
        </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4" formGroupName="gender">
          <p class="label-cls ddLabel">Gender</p>          
          <p-dropdown class="w-100" [options]="listGender" formControlName="id" optionLabel="name" optionValue="id" placeholder="Select" (onChange)="onGenderChange($event)"></p-dropdown> 
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">Date of Birth</label>
            <mat-form-field appearance="outline" class="mt-0 date-field w-100">
              <input formControlName="dob" matInput min="1920-12-31" [max]="currentDate" [matDatepicker]="dob"
                placeholder="MM/DD/YYYY" (click)="dob.open()" />
              <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">Social Security Number</label>
            <input class="m-0" type="text" id="ssnNumber" formControlName="ssn">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="label-cls">Alias Name</label>
            <input class="m-0" type="text" id="aliasName" formControlName="aliasName">
          </div>
        </div>
        <div class="col-3" formArrayName="emailContacts">
        <p class="label-cls" >Email Id</p>
      <ng-container *ngFor="
          let x of beneSelfDetailsForm.get('emailContacts')['controls'];
          index as i
        ">
        <div [formGroupName]="i">
          <input type="text" class="im-input m-0" [ngClass]="{
              'im-input-error':
                ((x.get('email').touched || submitted) &&
                  x.get('email').hasError('pattern')) ||
                ((x.get('email').touched || submitted) &&
                  x.get('email').hasError('required') )
            }" formControlName="email" placeholder="Enter"
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$" />
        </div>
        <span class="invalid-message" *ngIf="
            (x.get('email').touched || submitted) &&
            x.get('email').hasError('required')
          ">
          {{ getGlobalErrorMessages("REQUIRED") }}
        </span>
        <span class="invalid-message" *ngIf="
            (x.get('email').touched || submitted) &&
            x.get('email').hasError('pattern')
          ">
          {{ getGlobalErrorMessages("INVALID_EMAIL") }}
        </span>
      </ng-container>
    </div>
      </div>


      <div class="row mt-4">
        <div class="col-12">
          <h5 class="labelText">Place of Birth</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4"  formGroupName="countryCode">
          <div class="form-group">
            <label class="label-cls">Country</label>
            <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName" optionValue="countryCode" (onChange)="resetBirthStateOnCountryChange();
            handleCountryChange($event.value, 'Birth')" placeholder="Select" [filter]="true" filterBy="countryName"></p-dropdown> 
          </div>
        </div>
        <div class="col-md-4" *ngIf="listStatesBirth.length > 0">
          <div class="form-group">
            <label class="label-cls">State</label>
            <p-dropdown class="w-100" [options]="listStatesBirth" formControlName="birthStateProvinceCode" optionLabel="stateProvinceName"
            optionValue="stateProvinceCode" placeholder="Select State" [filter]="true" filterBy="stateProvinceName"></p-dropdown> 
          </div>
        </div>
        <div class="col-md-4" *ngIf="listStatesBirth.length <= 0">
          <div class="form-group">
            <label class="label-cls">State</label>
            <input class="im-input m-0" formControlName="birthStateProvinceName" type="text" placeholder="State" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group" formGroupName="ctznshipCountryCode">
            <label class="label-cls">Citizenship</label>
            <p-dropdown [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
            (onChange)="updateCountry($event.value, 'ctznshipCountryCode')"
              optionValue="countryCode" class="dropdown-sec w-100" placeholder="Select" #citznship [filter]="true" filterBy="countryName"></p-dropdown>
          </div>
        </div>
      </div>


      <div class="row mt-4">
        <div class="col-12">
          <h5 class="labelText">Physical Address Details</h5>
        </div>
      </div>

      <div formArrayName="address">
        <div [formGroupName]="getAddressGroup('CURR')">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label class="label-cls">Address 1</label>
                <input type="text" class="im-input m-0 col-md" formControlName="addressLine1" placeholder="Address 1"
                  maxLength="150" #currAddress1 />
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="label-cls">Address 2</label>
                <input type="text" class="im-input m-0 col-md" formControlName="addressLine2" placeholder="Address 2"
                  maxLength="150" #currAddress2 />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group" formGroupName="countryCode">
                <label class="label-cls">Country</label>
                <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
                optionValue="countryCode" (onChange)="handleCountryChange($event.value, 'Current');
                resetStateOnCountryChange(0)" placeholder="Select" [filter]="true" filterBy="countryName"></p-dropdown>            
              </div>
            </div>
            <div class="col-md-4" *ngIf="listStatesCurrent.length > 0">
              <div class="form-group">
                <label class="label-cls">State</label>
                <p-dropdown class="w-100" [options]="listStatesCurrent" formControlName="stateProvinceCode"
                optionLabel="stateProvinceName" optionValue="stateProvinceCode"
                (onChange)="handleStateChange($event.value,0)" placeholder="Select State" [filter]="true" filterBy="stateProvinceName"></p-dropdown> 
              </div>
            </div>
            <div class="col-md-4" *ngIf="listStatesCurrent.length <= 0">
              <div class="form-group">
                <label class="label-cls">State</label>
                <input class="im-input m-0" formControlName="stateProvinceName" type="text" placeholder="State" /> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">City</label>
                <input class="im-input m-0" formControlName="city" type="text" placeholder="City" /> 
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">Area</label>
                <input class="im-input m-0" formControlName="locality" type="text" placeholder="Area" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">Zip / Postal Code</label>
                <input class="im-input m-0" formControlName="postCode" type="text" maxLength="10" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-4">
          <h5 class="labelText">Foreign Address Details</h5>
        </div>

        <div class="col-4">
          <p class="label-cls ddLabel">Copy From</p>
          <p-dropdown class="w-100" [options]="listCopyMailAddress" optionLabel="name" optionValue="code"
            (onChange)="copyAddress($event.value, 'Foreign')" placeholder="Select"></p-dropdown>
        </div>
      </div>

      <div formArrayName="address">
        <div [formGroupName]="getAddressGroup('FORN')">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label class="label-cls">Address 1</label>
                <input type="text" class="im-input m-0 col-md" formControlName="addressLine1" placeholder="Address 1"
                  maxLength="150" />
              </div>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="label-cls">Address 2</label>
                <input type="text" class="im-input m-0 col-md" formControlName="addressLine2" placeholder="Address 2"
                  maxLength="150" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group" formGroupName="countryCode">
                <label class="label-cls">Country</label>
                <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName" 
                  optionValue="countryCode" (onChange)="
              handleCountryChange($event.value, 'Foreign'); resetStateOnCountryChange(1)" placeholder="Select"
                  styleClass="country-dd" [filter]="true" filterBy="countryName"></p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="listStatesForeign.length > 0">
              <div class="form-group">
                <label class="label-cls">State</label>
                <p-dropdown class="w-100" [options]="listStatesForeign" formControlName="stateProvinceCode"
                  optionLabel="stateProvinceName" optionValue="stateProvinceCode" placeholder="Select State"  (onChange)="handleStateChange($event.value,1)"
                  [filter]="true" filterBy="stateProvinceName"></p-dropdown>
              </div>
            </div>
            <div class="col-md-4" *ngIf="listStatesForeign.length <= 0">
              <div class="form-group">
                <label class="label-cls">State</label>
                <input class="im-input m-0" formControlName="stateProvinceName" type="text" placeholder="State" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">City</label>
                <input class="im-input m-0" formControlName="city" type="text" placeholder="City" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">Area</label>
                <input class="im-input m-0" formControlName="locality" type="text" placeholder="Area" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label-cls">Zip / Postal Code</label>
                <input class="im-input m-0" formControlName="postCode" type="text" maxLength="10" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <h5 class="labelText">Passport Details</h5>
        </div>
      </div>

      <div formArrayName="passport">
        <ng-container *ngFor="let x of beneSelfDetailsForm.get('passport')['controls']; index as i">
          <div [formGroupName]="i">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group">
                  <label class="label-cls">Passport No.</label>
                  <input type="text" class="im-input m-0 mw-100 m-0" formControlName="passportNo" placeholder="Passport #"
                    maxlength="9" />
                </div>
              </div>
              <div class="col-md-4" formGroupName="issueCountryCode">
                <div class="form-group">
                  <label class="label-cls">Issuing Authority</label>
                  <p-dropdown class="w-100" [options]="listCountry" formControlName="countryCode" optionLabel="countryName"
                    optionValue="countryCode" placeholder="Select" [filter]="true" filterBy="countryName"></p-dropdown>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="label-cls">Date of Issue</label>
                  <mat-form-field appearance="outline" class="mt-0 date-field w-100">
                    <input formControlName="issueDate" matInput [max]="currentDate" min="1920-12-12"
                      [matDatepicker]="issueDate" placeholder="MM/DD/YYYY" (click)="issueDate.open()" />
                    <mat-datepicker-toggle matSuffix [for]="issueDate"></mat-datepicker-toggle>
                    <mat-datepicker #issueDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="label-cls">Date of Expiry</label>
                  <mat-form-field appearance="outline" class="mt-0 date-field w-100">
                    <input placeholder="MM/DD/YYYY" [matDatepicker]="expiryDate" matInput formControlName="expiryDate"
                      max="9999-12-31" [min]="beneSelfDetailsForm.controls['passport']?.value[0] ?.issueDate" (change)="validateExpiry(beneSelfDetailsForm.controls['passport']?.value[0] ?.issueDate,
                          beneSelfDetailsForm.controls['passport']?.value[0] ?.expiryDate)"
                      (click)="expiryDate.open()" />
                    <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
                    <mat-datepicker #expiryDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <h5 class="labelText">Additional Info</h5>
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label class="label-cls">Visa Sponsor</label>
          <input class="im-input m-0" formControlName="visaSponsor" type="text"  />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <button type="button" (click)="savePersonalData()" class="btn btn-success button-width-icon-left mr-3">
            <i class="fa fa-floppy-o"></i>
            Save
          </button>
          <button type="button" (click)="clearForm()" class="back-button button-width-icon-left">
            <i class="fa fa-times-circle"></i>
            Cancel
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-4">
    <h5 class="labelText">Add passport photocopy</h5>
    <app-file-upload style="width: 100%;" [configurations]="fileUploadConfigurations">
    </app-file-upload>
  </div>


</mat-card>